/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatSummaryDTO } from '../models/ChatSummaryDTO';
import type { ChatSummaryJobInfo } from '../models/ChatSummaryJobInfo';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatSummaryControllerService {
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static createSummary({
        creatorId,
        userId,
        start,
    }: {
        creatorId: number,
        userId: number,
        start: string,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/summary/{userId}/createSummary',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
            query: {
                'start': start,
            },
        });
    }
    /**
     * @returns ChatSummaryDTO OK
     * @throws ApiError
     */
    public static getChatSummary({
        creatorId,
        userId,
    }: {
        creatorId: number,
        userId: number,
    }): CancelablePromise<ChatSummaryDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/summary/{userId}/getSummary',
            path: {
                'creatorId': creatorId,
                'userId': userId,
            },
        });
    }
    /**
     * @returns ChatSummaryJobInfo OK
     * @throws ApiError
     */
    public static getStatus({
        creatorId,
        jobId,
    }: {
        creatorId: number,
        jobId: string,
    }): CancelablePromise<ChatSummaryJobInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/summary/{jobId}/getJobStatus',
            path: {
                'creatorId': creatorId,
                'jobId': jobId,
            },
        });
    }
}
